import { useEffect, useState } from 'react';
import useFetch from '../../../api/useFetch';
import TypeCustomSelect from './TypeCustomSelect';
import { Box, Typography } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MoneyLabel from '../../label/MoneyLabel';
import { useTranslation } from 'react-i18next';

export const TypeBillablePosition = ({
  updateValidationOnChange,
  dataCollection,
  field,
  errors,
  startDataCollection,
  size,
  fallbackLabel,
}) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState([]);

  const { apiData } = useFetch(
    `project-positions?projectId[eq]=${field.projectId}`
  );

  useEffect(() => {
    if (apiData) setOptions(calcOptions());
  }, [apiData]);

  const iconMap = {
    time: AccessTimeIcon,
    flat: AttachMoneyIcon,
  };

  function calcOptions() {
    const newOptions = [];
    apiData.data.forEach((position) => {
      const { id, name, type, image, price, unit } = position;
      const priceMap = {
        time: (
          <>
            <MoneyLabel money={price} />
            <span style={{ fontSize: 10 }} className="ml-1 opacity-50">
              {`/ ${t('hour')}`}
            </span>
          </>
        ),
        flat: (
          <>
            <MoneyLabel money={price} />
            {unit && (
              <span style={{ fontSize: 10 }} className="ml-1 opacity-50">
                {` / ${unit}`}
              </span>
            )}
          </>
        ),
      };

      const Icon = iconMap[type];
      const priceLabel = priceMap[type];

      newOptions.push({
        label: (
          <Box className="flex justify-between gap-2 w-full">
            <Box className="flex gap-2">
              {image ? (
                <img
                  className="w-[21px] h-[21px] rounded-md object-cover"
                  src={image.temporaryUrl}
                />
              ) : (
                <Icon />
              )}
              <Typography fontWeight={500}>{name}</Typography>
            </Box>
            <Typography>{priceLabel}</Typography>
          </Box>
        ),
        value: id,
      });
    });
    return newOptions;
  }

  function handleChange(key, value) {
    const position = apiData.data.find((obj) => obj.id === value);
    updateValidationOnChange(field.key, position);
  }

  const { id } = dataCollection[field.key] || {};

  return (
    <TypeCustomSelect
      field={{ ...field, options }}
      dataCollection={{ [field.key]: id }}
      updateValidationOnChange={handleChange}
      size={size}
      startDataCollection={startDataCollection}
    />
  );
};
